import * as React from 'react';
import './index.css';
import { i18nClient } from '@sailor/i18n-mach-pro';
import { cloneDeep } from 'lodash';
import CurrencyText from '@/src/components/CurrencyText';
import { Lx } from './statistic';

interface IProps {
  cid: string;
  paymentMethodList: any[];
  supportRefundTypePreference?: number;
  onClose?: () => void;
  onRefund?: (item, type) => void;
  refundTypePreference?: number;
}

interface IState {
  paymentDataList: any[];
  refundMethodPreferenceTipSelected: boolean;
  preferenceFirstSelected: boolean;
}

const Toast = Mach.requireModule('Toast');

export class RefundMethodView extends React.Component<IProps, IState> {
  contentRef: any = null;

  constructor(props: IProps) {
    super(props);
    const paymentMethodList = cloneDeep(this.props.paymentMethodList) || [];
    const defaultSelectedItem = paymentMethodList.find((item) => item.defaultSelected === 1);
    if (defaultSelectedItem) {
      defaultSelectedItem.selected = true;
    } else if (this.props?.refundTypePreference === 1 && this.props?.supportRefundTypePreference === 1) {
      paymentMethodList.forEach((item) => {
        if (item.code === 1) {
          item.selected = true;
        } else {
          item.selected = false;
        }
      });
    }

    this.state = {
      paymentDataList: cloneDeep(paymentMethodList),
      refundMethodPreferenceTipSelected: this.props?.refundTypePreference === 1 || false,
      preferenceFirstSelected: this.props?.refundTypePreference === 1 || false,
    };
    Lx.setCid(this.props.cid);
  }

  componentDidMount(): void {
    // 曝光
    Lx.refundMethodViewMv();
  }

  /**
     * 点击关闭按钮
     */
  onClickClose = () => {
    // 关闭回调
    if (this.props.onClose) {
      this.props.onClose();
    }
    // 点击埋点
    Lx.closeBtnMc();
  }

  /**
     * 点击退款方式
     * @param item
     */
  handleClickPaymentItem = (item) => {
    const { paymentDataList } = this.state;
    // eslint-disable-next-line no-return-assign
    paymentDataList?.map?.((it) => it.selected = false);
    item.selected = true;
    this.setState({
      paymentDataList,
    });

    // 点击埋点
    const params = {
      refund_to_type: item.code ?? '-999',
    };
    Lx.refundMethodItemMc(params);
  }

  /**
     * 点击默认退款方式偏好
     */
  handleClickRefundMethodPreferenceTip = () => {
    const { refundMethodPreferenceTipSelected, preferenceFirstSelected } = this.state;
    this.setState({
      refundMethodPreferenceTipSelected: !refundMethodPreferenceTipSelected,
    });
    if (!preferenceFirstSelected) {
      this.setState({
        preferenceFirstSelected: true,
      });
      Toast.show(i18nClient.getText('refund_detail_wallet_default_toast'), 2);
    }
  }

  /**
     * 点击退款按钮
     */
  handleRefund = () => {
    const { paymentDataList, refundMethodPreferenceTipSelected } = this.state;
    // eslint-disable-next-line no-return-assign
    const item = paymentDataList?.find?.((it) => it.selected === true);
    const type = (refundMethodPreferenceTipSelected && (item?.code === 1)) ? 1 : 0;

    // 点击埋点
    const params = {
      refund_to_type: item?.code ?? '-999',
      is_default: type,
    };
    Lx.refundMethodConfimBtnMc(params);

    if (!item) {
      return;
    }
    // 退款回调
    this.props.onRefund?.(item, type);
    // 关闭回调
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  /**
     * 渲染退款方式item
     * @param item
     * @param index
     * @returns
     */
  renderPaymentItem = (item) => {
    const supportRefundTypePreference = this.props?.supportRefundTypePreference || 0;
    const showRefundTypePreference = supportRefundTypePreference === 1;
    const isItemAvailable = item?.available;
    return (
      <view
        className="payment-item"
        onClick={() => {
          if (isItemAvailable) {
            this.handleClickPaymentItem(item);
          }
        }}
      >
        <image
          className="payment-item-icon"
          src={item.selected ? 'assets://order/order_refund/order_refund_reason_selected.png' : 'assets://order/order_cancel_reason_unselected.png'}
        />
        <view className="payment-item-info">
          <view className="payment-item-title-container">
            <text className="payment-item-title" content={item.name} />
            {item.label ? (
              <view className="payment-item-tag">
                <view className="payment-item-tag-bg" />
                <image
                  className="payment-item-tag-icon"
                  src="assets://order/order_status_golden/refund_method_hot.png"
                />
                <text className="payment-item-tag-title" content={item.label || ''} />
              </view>
            ) : null}
          </view>
          {item.subLabel ? (
            <text className="payment-item-subtitle" content={item.subLabel || ''} />
          ) : null}
          {item.refundMethodPreferenceTip && item.selected && showRefundTypePreference ? (
            <view
              className="payment-item-refundMethodPreferenceTip"
              onClick={this.handleClickRefundMethodPreferenceTip}
            >
              <image
                className="payment-item-refundMethodPreferenceTip-icon"
                src={this.state.refundMethodPreferenceTipSelected ? 'assets://order/order_refund/refundMethodPreferenceTip-icon-selected.png' : 'assets://order/order_refund/refundMethodPreferenceTip-icon-unselected.png'}
              />
              <text className="payment-item-refundMethodPreferenceTip-title" content={item.refundMethodPreferenceTip || ''} />
            </view>
          ) : null}
        </view>
      </view>
    );
  }

  render(): React.ReactNode {
    const { paymentDataList } = this.state;
    const title = i18nClient.getText('Refund_method_select');
    const selectItem = paymentDataList?.find?.((it) => it.selected === true);
    return (
      <view className="root">
        <view className="container">
          <view
            className="close-button"
            style={{
              paddingTop: Mach.env.statusBarHeight + Mach.env.navigationBarHeight,
            }}
            onClick={() => {
              this.onClickClose();
            }}
          >
            <image className="close-image" src="assets://order/order_evaluate_close.png" />
          </view>
          <view className="info-container">
            <view className="title-container">
              <text className="title" content={title} />
            </view>
            <scroller
              className="payment-container"
              showScrollIndicator={false}
            >
              <content>
                {paymentDataList?.map?.((item, index) => this.renderPaymentItem(item, index))}
              </content>
            </scroller>
            <view className="refund-btn-container">
              <view
                className="refund-btn"
                style={{
                  backgroundColor: selectItem ? '#FFE41F' : '#CACACA',
                }}
                onClick={this.handleRefund}
              >
                <text
                  className="refund-btn-title"
                  style={{
                    color: selectItem ? '#222222' : '#FFFFFF80',
                  }}
                  content={i18nClient.getText('Refund_method_button')}
                />
              </view>
            </view>
          </view>
        </view>
        <view
          className="safe-area-container"
          style={{
            height: Mach.env.safeAreaInsets?.bottom || 20
          }}
        />
      </view>
    );
  }
}
